import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { AuthService } from '../auth/data-access/auth.service';

let showingExpiredModal = false;

export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const isExpiredSession = err.status === 401 && authService.isAuthenticated();

      if (isExpiredSession && !showingExpiredModal) {
        showingExpiredModal = true;
        Swal.fire({
          html: 'Ha superado el tiempo límite de inactividad, vuelva a iniciar sesión',
          icon: 'warning',
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false,
        }).then(() => {
          showingExpiredModal = false;
          authService.logout();
          router.navigateByUrl('/login');
        });
      }

      return throwError(() => err);
    }),
  );
};
